/** 系统级：约束 thinking/reasoning 语言 */
export const ZZL_THINKING_SYSTEM_HINT =
  '你必须使用中文进行思考（reasoning/thinking 过程只能使用中文，禁止用英文思考）。';

/** 用户消息开头：再次强调 */
export const ZZL_THINKING_PROMPT_HINT =
  '【重要要求】请用中文思考，思考过程不得使用英文。';

export function buildZzlChatUserContent(userText, aiText) {
  const parts = [ZZL_THINKING_PROMPT_HINT];
  if (userText && String(userText).trim()) {
    parts.push(String(userText).trim());
  }
  if (aiText && String(aiText).trim()) {
    parts.push(String(aiText).trim());
  }
  return parts.join('\n\n');
}

/** @returns {{ role: string, content: string }[]} */
export function buildZzlChatMessages(userText, aiText) {
  return [
    { role: 'system', content: ZZL_THINKING_SYSTEM_HINT },
    { role: 'user', content: buildZzlChatUserContent(userText, aiText) },
  ];
}
